var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, splitStringByLineLength } from '@shapeable/utils';
import { reverse, kebabCase } from 'lodash';
import { animated } from '@react-spring/web';
import { SvgCircle } from './svg-circle';
import { useStaticColors } from '../hooks/use-theme-colors';
import { useSpringValues } from '../hooks/use-spring-values';
import { useThemeEval } from '../hooks/use-theme-eval';
var cls = classNames('svg-label');
export var SvgLabelDefaultProps = {
  x: 0,
  y: 0,
  opacity: 1,
  lineLength: 14,
  fontSize: 14,
  dy: 0,
  text: '',
  debug: false,
  lineHeight: 1.2,
  fontWeight: 400,
  fontFamily: 'sans',
  textAnchor: 'middle',
  verticalOrigin: 'top',
  lineOrigin: 'default',
  colors: {
    fill: 'strong'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TextStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    user-select: none;\n\n    ", "\n\n  "], ["\n    user-select: none;\n\n    ", "\n\n  "])), function (_a) {
    var debug = _a.debug;
    return debug && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      outline: 1px solid black;\n    "], ["\n      outline: 1px solid black;\n    "])));
  })
});
var LineStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled(animated.svg)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Text: styled(animated.text).attrs(cls.attr('text'))(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), TextStyles),
  Line: styled(animated.tspan).attrs(cls.attr('tspan'))(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LineStyles)
};
export var SvgLabel = function (props) {
  var id = props.id,
    className = props.className,
    lineLength = props.lineLength,
    fontSize = props.fontSize,
    fontWeight = props.fontWeight,
    text = props.text,
    lineHeight = props.lineHeight,
    debug = props.debug,
    textAnchor = props.textAnchor,
    verticalOrigin = props.verticalOrigin,
    lineOrigin = props.lineOrigin;
  var labelLines = splitStringByLineLength(text, lineLength).filter(function (line) {
    return !!line.trim();
  });
  var lines = verticalOrigin === 'top' ? labelLines : reverse(labelLines);
  var dy = props.dy;
  var staticColors = useStaticColors(props.colors);
  var values = useSpringValues(props);
  var $ = useThemeEval();
  var fontFamily = $(theme.FONT(props.fontFamily));
  var shadowId = "".concat(id || kebabCase(text), "-shadow");
  if (!text) {
    return null;
  }
  return React.createElement(My.Container, {
    x: values.x,
    y: values.y,
    overflow: "visible",
    className: cls.name(className)
  }, debug && React.createElement(SvgCircle, {
    r: 2,
    cx: 0,
    cy: 0,
    colors: {
      stroke: 'strong'
    }
  }), React.createElement("defs", null, React.createElement("filter", {
    id: shadowId
  }, React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: "2",
    result: "blur"
  }), React.createElement("feOffset", {
    dx: "0",
    dy: "0",
    result: "offsetBlur"
  }), React.createElement("feFlood", {
    floodColor: "black",
    result: "outlineColor"
  }), React.createElement("feComposite", {
    in2: "offsetBlur",
    operator: "in",
    in: "outlineColor",
    result: "outline"
  }), React.createElement("feMerge", null, React.createElement("feMergeNode", {
    in: "outline"
  }), React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), React.createElement(My.Text, {
    debug: debug ? true : undefined,
    opacity: values.opacity,
    fill: staticColors.fill,
    stroke: staticColors.stroke,
    x: 0,
    y: 0,
    fontSize: fontSize,
    fontWeight: fontWeight,
    fontFamily: fontFamily,
    textAnchor: textAnchor
  }, lines.map(function (word, i) {
    var dyIsDefault = i == 0 && lineOrigin === 'default';
    var lineDy = dy;
    if (verticalOrigin === 'top') {
      if (!dyIsDefault) {
        lineDy = lineHeight + dy;
      }
      if (i === 0 && lineOrigin === 'default') {
        lineDy = dy;
      } else if (i !== 0 && lineOrigin === 'precise') {
        lineDy = lineHeight + dy;
      } else if (i === 0 && lineOrigin === 'precise') {
        lineDy = 1 + dy;
      } else if (i !== 0 && lineOrigin === 'default') {
        lineDy = lineHeight + dy;
      }
    } else if (verticalOrigin === 'bottom') {
      if (i === 0) {
        lineDy = -dy - 0.2;
      } else {
        lineDy = -lineHeight - dy;
      }
    } else if (verticalOrigin === 'middle') {
      if (i === 0) {
        lineDy = dy + lines.length / 2;
      } else {
        lineDy = -lineHeight - dy;
      }
    }
    return React.createElement(My.Line, {
      key: "line-".concat(i),
      dy: "".concat(lineDy, "em"),
      x: 0
    }, word);
  })));
};
SvgLabel.cls = cls;
SvgLabel.defaultProps = SvgLabelDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;